import { render, staticRenderFns } from "./CreateExam.vue?vue&type=template&id=4490ee30&"
import script from "./CreateExam.vue?vue&type=script&lang=js&"
export * from "./CreateExam.vue?vue&type=script&lang=js&"
import style0 from "./CreateExam.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports